{{extend './form_line.art'}}
{{block 'line'}}

<select name="{{attr.name}}"{{if attr.other}} {{@ attr.other}}{{/if}}>
{{each data.list item}}
    <option value="{{item.value}}">{{item.name}}</option>
{{/each}}
</select>

{{/block}}